import * as router from './router-service';
import * as api from './api-service'; 

export default {
    router,
    api, 
};